export default {
  PlayerHighlight: true, // Will require new module on stable release
  HubPages: true, // Will be added as part of pages on stable release
  MatchdayTakeover: true, // Will require new module on stable release
  TempSocialFeed: true,
  WhereToStream: true,
  PlayerProfileStats: false
}
